export default __webpack_public_path__ + "static/fr_ln-6bfab6d0f7b325c43d3a14d5d82a7b3a.gif";